import { SetupFinishStep } from "@/components/setup/setup-finish-step";

export const SetupResubscriptionFinishPage = () => (
  <SetupFinishStep
    apiEndpoint="/my/team/setup/finish-resubscription"
    translationPrefix="setup.resubscription.finish"
    successButtonKey="letsGo"
  />
);
